module.exports = __webpack_public_path__ + "img/23.b398ea71.svg";